import { IconProps } from '../types';
import Theme from '../../../components-library/Theme';
import React from 'react';

export default function StarOutlineIcon({ color, className }: IconProps) {
  return (
    <svg className={className ?? 'w-4'} viewBox="0 0 27 25" fill="none">
      <path
        d="M8.54282 20.5526L13.5007 17.5842L18.4586 20.5842L17.1323 14.9632L21.4902 11.1737L15.7428 10.6684L13.5007 5.36316L11.2586 10.6368L5.51125 11.1421L9.86914 14.9316L8.54282 20.5526ZM5.70072 24.5L7.75335 15.6263L0.869141 9.65789L9.96388 8.86842L13.5007 0.5L17.0376 8.86842L26.1323 9.65789L19.2481 15.6263L21.3007 24.5L13.5007 19.7947L5.70072 24.5Z"
        fill={color ?? Theme.color.black.DEFAULT}
      />
    </svg>
  );
}
